import { protectedComponentHoc } from "../../../../components/ProtectedComponent";
import InsurerComponent from "./component";

export const Insurer = protectedComponentHoc(InsurerComponent);
